import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentRenderer from '../ContentRenderer/ContentRenderer';
import ContentLinkRenderer from '../ContentLinkRenderer/ContentLinkRenderer';

class ContentTiles extends Component {
  
  state = {
    items: null
  };
  
  componentDidMount() {
    this.fetchData()
  }
  
  fetchData = async () => {
    try {
      const response = await fetch(this.props.jsonDataUrl);
      if (response.ok) {
        this.setState({
          items: await response.json()
        })
      } else {
        throw response;
      }
    } catch (e) {
      console.log(e);
    }
  };
  
  render() {
    return (
      <div className="box-wrapper">
        <div className="fg fg--box-wrapper">
          {
            this.state.items ? this.state.items.map((item, index) => {
              return (
                <div key={index} className="fg__col-lg-4 fg__col-md-6 fg__col-sm-12">
                  <div className="content-container background-white">
                    <div className="two-three-rows__image-container">
                      <img src={item.image} alt="" className="cover-image"/>
                    </div>
                    <div className="two-three-rows__card-text">
                      <h2 className="two-three-rows__item-title">{item.title}</h2>
                      <div className="mb36">
                        <ContentRenderer
                          contentType={item.content.type}
                          value={item.content.value}
                        />
                      </div>
                      <ContentLinkRenderer
                        contentType={item.detailContent.type}
                        value={item.detailContent.value}
                        linkContent="Learn"
                        className="learn-more-link"
                        target={item.detailContent.target}
                        pathForItem={this.props.pathForItem}
                        id={item.id}
                      />
                    </div>
                  </div>
                </div>
              )
            }) : null
          }
        </div>
      </div>
    )
  }
}

export default ContentTiles;

ContentTiles.propTypes = {
  jsonDataUrl: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/ContentTiles/ContentTiles.js